export const ButtonColors = {
  blue: 'blue',
  green: 'green',
};
